import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { REMAINING_MINUTES_FOR_NOTIFY } from '../../../app.config.vars/stored';
const TimeExpireNotification = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content time-expire-notification', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('time_expire_notification', { minutes: REMAINING_MINUTES_FOR_NOTIFY }), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: t('button.ok'), onClick: async () => {
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                    } }) })] }));
};
export default TimeExpireNotification;
